// src/sections/DatenloggerSection.jsx
import { useState, useEffect } from "react";
import { Box, Heading, Grid, Input, Button, VStack } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";

export default function DatenloggerSection({ selectedAnlageId }) {
  const [datenlogger, setDatenlogger] = useState([
    { hersteller: "", modell: "", ipAdresse: "", login: "", passwort: "" },
  ]);
  const [herstellerList, setHerstellerList] = useState([]);

const [showPassword, setShowPassword] = useState({});

  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/datenlogger/anlage/${selectedAnlageId}`)
      .then((res) => {
        setDatenlogger(res.data.length ? res.data : [
          { hersteller: "", modell: "", ipAdresse: "", login: "", passwort: "" }
        ]);
      })
      .catch(() => {
        setDatenlogger([{ hersteller: "", modell: "", ipAdresse: "", login: "", passwort: "" }]);
      });
  }, [selectedAnlageId]);


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/hersteller`)
      .then((res) => setHerstellerList(res.data))
      .catch((err) => console.error("Error loading Hersteller:", err));
  }, []);

  const handleSave = async () => {
    try {
      const filled = datenlogger.filter((d) => d.hersteller);
      for (const d of filled) {
        if (d.id) {
          await axios.put(`${process.env.REACT_APP_API_URL}/api/datenlogger/${d.id}`, {
            ...d,
            anlage: { id: selectedAnlageId },
          });
        } else {
          await axios.post(`${process.env.REACT_APP_API_URL}/api/datenlogger`, {
            ...d,
            anlage: { id: selectedAnlageId },
          });
        }
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/datenlogger/anlage/${selectedAnlageId}`
      );
      setDatenlogger(res.data);
      showSuccess("Erfolg!", "Datenlogger gespeichert oder aktualisiert.");
    } catch {
      showError("Fehler!", "Speichern fehlgeschlagen.");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/datenlogger/${id}`);
      showSuccess("Erfolg!", "Datenlogger gelöscht.");
    } catch {
      showError("Fehler!", "Löschen fehlgeschlagen.");
    }
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...datenlogger];
    updated[index][name] = value;
    setDatenlogger(updated);
  };

  const addRow = () =>
    setDatenlogger((prev) => [...prev, { hersteller: "", modell: "", ipAdresse: "", login: "", passwort: "" }]);

  const removeRow = (index) =>
    setDatenlogger((prev) => prev.filter((_, i) => i !== index));

  return (
        <Box 
      p={8} 
      bg="white" 
      borderRadius="xl" 
      boxShadow="md" 
      mt={6} 
      mb={10} 
      maxW="fit-content"
    >
      <Heading fontSize="21px" mb={6} color="black.600">
        DATENLOGGER
      </Heading>

      <VStack spacing={4} align="stretch">
        {datenlogger.map((d, index) => (
          <Grid
            key={index}
            templateColumns="repeat(6, 1fr) 60px"
            gap={4}
            alignItems="center"
            bg="gray.50"
            p={4}
            rounded="lg"
          >
            <select
              name="hersteller"
              value={d.hersteller}
              onChange={(e) => handleChange(index, e)}
            >
              <option value="">Hersteller wählen</option>
              {herstellerList.map((h) => (
                <option key={h.id} value={h.name}>
                  {h.name}
                </option>
              ))}
            </select>

            <Input name="modell" placeholder="Modell" value={d.modell} onChange={(e) => handleChange(index, e)} />
            <Input name="ipAdresse" placeholder="IP-Adresse" value={d.ipAdresse} onChange={(e) => handleChange(index, e)} />
            <Input name="login" placeholder="Login" value={d.login} onChange={(e) => handleChange(index, e)} />

            <Input
              name="passwort"
              type={showPassword[index] ? "text" : "password"}
              value={d.passwort}
              onChange={(e) => handleChange(index, e)}
            />


            <Button
                size="xs"
              bg="#B8860B"
              color="white"
              _hover={{ bg: "#C99414" }}
              onClick={() =>
                setShowPassword((p) => ({ ...p, [index]: !p[index] }))
              }
            >
              {showPassword[index] ? "Passwort ausblenden" : "Passwort anzeigen"}
            </Button>

          
            <Button
               bg="#B22222" // Firebrick red (similar depth to your gold)
              color="white"
              _hover={{ bg: "#D22B2B" }} // Slightly lighter red on hover
              size="md"
              width="fit-content"
              onClick={() => {
                removeRow(index);
                if (d.id) handleDelete(d.id);
              }}
            >
              Löschen
            </Button>
          </Grid>
        ))}

        <Button 
        bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          width="fit-content"
          size="md"
        
        onClick={addRow}>
          + Neuer Datenlogger
        </Button>

        <Button 
        bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          width="fit-content"
          size="md"
        
        onClick={handleSave}>
          Speichern Datenlogger
        </Button>
      </VStack>
    </Box>
  );
}